import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface ManagementUseOfExpertRommsProps {
  onBack: () => void;
}

export default function ManagementUseOfExpertRomms({ onBack }: ManagementUseOfExpertRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Management use of Expert" />;
}
